import React from "react";
import PropTypes from "prop-types";

import { AppIcons } from "../../../data/appIcons";
import Buttons from "../button/Buttons";
import Image from "../../image/Image";

const FilePreview = ({
  fileValues = [],
  isMultipleFileAllowed = false,
  onClearClick,
  onDownloadClick,
  onClearAll,
  isDownloadButton,
  isDisable
}) => (
  <>
    {isMultipleFileAllowed && fileValues.length > 0 ? (
      <div className="top-title-btn">
        <div className="list-title">File List</div>
        {isMultipleFileAllowed && fileValues.length > 0 && (
          <button className="danger-btn ml-2"
            onClick={onClearAll} disabled={isDisable}
            aria-label="Clear All Files">
            Clear All
          </button>
        )}
      </div>
    ) : null}

    {/* {isShowCustomPreview && */}
    <div className={`${isMultipleFileAllowed && fileValues.length > 0 ? "file-preview-list" : null}`}>
      {fileValues.length > 0 &&
        <div className="file-list-heading">
          <div>File Name</div>
          <div>Action</div>
        </div>
      }
      {fileValues.length > 0 &&
        fileValues.map((file, index) => (
          <div key={index + 1} className="file-preview-sec">
            <div className="custom-file-selector-design">
              <Image
                imagePath={AppIcons.UploadDocsIcon}
                altText="Upload File"
              ></Image>
              <div className="file-preview-name">
                <p className="file-name" key={index + 1}>
                  {file.name}
                </p>
                <div
                  className={`${isMultipleFileAllowed ? "is-multi-btn" : null}`}
                >
                  <div className="clear-buttons clear-btn-sec">
                    {isMultipleFileAllowed ? (
                      <Buttons
                        buttonTypeClassName="clear-button"
                        textWithIcon={false}
                        onClick={() => onClearClick(index)}
                        isIcon={true}
                        iconClass="fluent:delete-16-regular"
                        isTooltip={true}
                        tootipText="Delete File"
                      />
                    ) : (
                      <Buttons
                        buttonTypeClassName="btn dark-btn"
                        buttonText="Clear"
                        onClick={() => onClearClick(0)}
                      />
                    )}
                  </div>
                  {isDownloadButton && (
                    <Buttons
                      buttonTypeClassName="download-button"
                      textWithIcon={false}
                      onClick={() => onDownloadClick(index)}
                      isIcon={true}
                      iconClass="ooui:download"
                      isTooltip={true}
                      tootipText="Download File"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
    {/* } */}
  </>
);

FilePreview.propTypes = {
  fileValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
      size: PropTypes.number,
    })
  ).isRequired,
  isMultipleFileAllowed: PropTypes.bool,
  onClearClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  isDownloadButton: PropTypes.bool,
};

export default FilePreview;